"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgPaperclip(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 16 23",
    fill: "none",
    stroke: "#007AFF",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.405 13.17l-3.34 5.787a5.749 5.749 0 01-9.958-5.748l5.729-9.922a3.797 3.797 0 016.576 3.798l-5.77 9.994a1.888 1.888 0 11-3.27-1.888l4.953-8.58"
  }));
}

var MemoSvgPaperclip = /*#__PURE__*/React.memo(SvgPaperclip);
var _default = MemoSvgPaperclip;
exports["default"] = _default;